import * as _ from '../product/linetype.model';
import * as h from '../order/orderhighlevel.model';
// import * as c from '../order/condtype.model';
import * as o from '../order/orderdisc.model';
export class OrderDetailModel {
    so_no: string
    so_item: string
    
    isprd_name_change: boolean //Check features on from admin
    is_prd_name_changed: boolean= false // Check description changed or not

    item_category: string
    // sales_ind: number 

    line_type: _.LineTypeModel
    // line_type_code: string
    prd_code: string
    prd_name: string
    uom_code: string
    quantity: number
    // TODO: this property always equal to quantity
    // TODO: what is the purpose of this?
    default_quantity: number
    status: string
    status_desc: string
    plant: string
    
    gross_amt: number
    // net_amount: number;
    // tax_amount: number
    // discount_amount: number

    // total_gross_amt: number
    // total_net_amount: number
    // total_tax_amount: number
    // total_discount_amount: number

    ttl_gross_amt: number
    ttl_net_amt: number
    ttl_tax_amt: number
    ttl_disc_amt: number
    
    bonus: string
    stock_amount: string
    high_level: h.OrderHighLevelModel
    foc_item: OrderDetailModel[] = []
    bom_item: OrderDetailModel[] = [] // CCLIORDER-1604
    cond_type: o.OrderDiscModel[] = [] //.ConditionTypeModel[] = []

    foc_del_ind: number = 0
    viewable: number

    sloc_code: string
    batch_no: string
    batch_exp_date: string
    // STRY0017241 - Add shipping point as additional field - EPC
    shipping_point: string

    parent_prd : string
    itmtxt:string
    tdid:string
    base_uom: string = ""
    // to determine display bom details
    display_bom_detail: boolean = false;
    isParentBom: boolean = false;
    isChildBom: boolean = false;
    packageBomUID: string = '';
    lastIndexOfBomPackage: number = 0;
    /**
     * This one use for bom material only
     * BOM is a set of material. When you change the quantity of the parent, the children quantity will follow a particular ratio
     * Ex: Dummy bomb has 3 children and its ratio is 1:3:2
     * Parent 1: Children 1:3:2
     * Parent 2: Chidlren 2:6:4
     */
    quantity_ratio: number = 0;

    lead_time:string;
    shelf_life:string;
    registration_no:string;
}


// WEBPACK FOOTER //
// ./src/models/order/orderdetail.model.ts